// Fila de analytics para envio quando online
interface AnalyticsPing {
	playerId: string;
	timestamp: number;
	data: Record<string, unknown>;
}

const QUEUE_KEY = "analyticsQueue";
const MAX_QUEUE_SIZE = 100; // Limita tamanho da fila

export const analyticsQueue = {
	// Retorna fila atual
	getQueue(): AnalyticsPing[] {
		try {
			return JSON.parse(localStorage.getItem(QUEUE_KEY) || "[]");
		} catch {
			return [];
		}
	},

	// Adiciona ping à fila (quando offline)
	enqueue(ping: Omit<AnalyticsPing, "timestamp">) {
		const queue = this.getQueue();

		// Limita tamanho da fila (remove mais antigos)
		if (queue.length >= MAX_QUEUE_SIZE) {
			queue.shift();
		}

		queue.push({
			...ping,
			timestamp: Date.now(),
		});

		localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
	},

	// Remove ping da fila (após envio bem-sucedido)
	dequeue(): AnalyticsPing | undefined {
		const queue = this.getQueue();
		const ping = queue.shift();
		localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
		return ping;
	},

	// Limpa fila inteira
	clear() {
		localStorage.removeItem(QUEUE_KEY);
	},

	// Retorna quantidade na fila
	get size(): number {
		return this.getQueue().length;
	},
};
